import React from 'react';
import { Typography, Box, createTheme, ThemeProvider } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { ISwitchWithCustomText } from '../Switch/SwitchWithCustomText';
import { IUserConfiguration } from '../../redux/configuration/types';
import { FAQ } from '../../pages';

export interface ISettingsProps extends Omit<ISwitchWithCustomText, 'header' | 'body' | 'theme'> {
    onChange?: (payload: any) => void;
    setting?: IUserConfiguration;
}

const AccountHelp: React.FC<ISettingsProps> = props => {
    const { themeStyle } = useThemeContext();

    const switchTheme = createTheme({
        components: {
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        // Controls default (unchecked) color for the thumb
                        color: theme[themeStyle].tag_white,
                    },
                    colorPrimary: {
                        '&.Mui-checked': {
                            // Controls checked color for the thumb
                            color: theme[themeStyle].tag_white,
                        },
                    },
                    track: {
                        // Controls default (unchecked) color for the track
                        opacity: 1,
                        backgroundColor: theme[themeStyle].gray_message,
                        '.Mui-checked.Mui-checked + &': {
                            // Controls checked color for the track
                            opacity: 0.9,
                            backgroundColor: theme[themeStyle].primary_orange,
                        },
                    },
                },
            },
            //@ts-ignore
            custom: {},
        },
    });

    return (
        <ThemeProvider theme={switchTheme}>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                }}
                sx={{
                    gap: '30px',
                    width: '100%',
                    height: '100%',
                    p: {
                        xs: 2,
                        sm: 0,
                    },
                }}>
                <Typography
                    style={{
                        fontSize: 36,
                        fontWeight: '600',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        textAlign: 'left',
                        color: theme[themeStyle].filters_white,
                    }}>
                    Help
                </Typography>
                <FAQ />
            </Box>
        </ThemeProvider>
    );
};

export { AccountHelp };
